module.exports = __webpack_public_path__ + "img/mobile-unlocked.1c6ae27b.png";